(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clb-scroll-bg"] && !Shopify.designMode) return;
  try {
    
  // One-shot reveal fallback — ONLY for browsers without scroll-driven
  // animations. Modern browsers use the pure-CSS view() timeline and this
  // does nothing. Reduced-motion is respected (no motion added).
  (function () {
    if (window.customElements && customElements.get('clb-scroll')) return;

    var supportsTimeline =
      window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    var reducedMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class ClbScroll extends HTMLElement {
      connectedCallback() {
        if (supportsTimeline || reducedMotion) return;
        var self = this;
        var run = function () { self.wire(); };
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', run, { once: true });
        } else {
          run();
        }
      }

      wire() {
        if (!('IntersectionObserver' in window)) return;
        var els = document.querySelectorAll('.clb-reveal');
        if (!els.length) return;
        for (var i = 0; i < els.length; i++) els[i].classList.add('clb-reveal--js');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in');
              io.unobserve(entry.target);
            }
          });
        }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
        for (var j = 0; j < els.length; j++) io.observe(els[j]);
      }
    }

    customElements.define('clb-scroll', ClbScroll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stuburt-collection-hero"] && !Shopify.designMode) return;
  try {
    
  // The hero loop is decorative and unclickable, so a blocked autoplay would
  // strand it on the poster with no way back. Safari/iOS sometimes ignore the
  // HTML muted attribute and deny autoplay; re-asserting muted in JS before
  // play() recovers it. Retries on the first real user gesture, which counts
  // as an unlock, and after a tab returns to the foreground.
  (() => {
    const vids = document.querySelectorAll('.stuburt-collection-hero__video');
    if (!vids.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const kick = () => {
      vids.forEach((v) => {
        if (!v.paused) return;
        v.muted = true;
        const p = v.play();
        if (p) p.catch(() => {});
      });
    };
    kick();
    document.addEventListener('touchend', kick, { once: true, passive: true });
    document.addEventListener('click', kick, { once: true });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) kick();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stuburt-glove-banner"] && !Shopify.designMode) return;
  try {
    
  /* Advances the snap track. Swiping needs none of this; it only moves the
     slides on a timer and keeps the dots honest. No autoplay under reduced
     motion or in the theme editor, and it holds while anything inside has
     keyboard focus or the tab is hidden. */
  if (!customElements.get('stuburt-hero-rotator')) {
    customElements.define('stuburt-hero-rotator', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track || this.track.children.length < 2) return;
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.count = this.track.children.length;
        this.index = 0;
        this.delay = Math.max(3, parseFloat(this.dataset.seconds) || 6) * 1000;
        this.still = window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
          Boolean(window.Shopify && window.Shopify.designMode);
        this.holds = new Set();

        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.go(i)));
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, { passive: true });
        this.addEventListener('pointerdown', () => this.start());
        this.addEventListener('focusin', () => this.hold('focus'));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.release('focus');
        });
        this.onVisibility = () => (document.hidden ? this.hold('hidden') : this.release('hidden'));
        document.addEventListener('visibilitychange', this.onVisibility);
        this.start();
      }
      disconnectedCallback() {
        this.stop();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }
      hold(reason) { this.holds.add(reason); this.stop(); }
      release(reason) { this.holds.delete(reason); this.start(); }
      stop() { clearTimeout(this.timer); }
      start() {
        this.stop();
        if (this.still || this.holds.size) return;
        this.timer = setTimeout(() => this.go((this.index + 1) % this.count), this.delay);
      }
      go(i) {
        this.gliding = performance.now() + 900;
        this.track.scrollTo({ left: i * this.track.clientWidth, behavior: this.still ? 'auto' : 'smooth' });
        this.set(i);
        this.start();
      }
      sync() {
        if (performance.now() < (this.gliding || 0)) return;
        const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (i !== this.index) { this.set(i); this.start(); }
      }
      set(i) {
        this.index = i;
        this.dots.forEach((dot, n) => dot.setAttribute('aria-current', n === i ? 'true' : 'false'));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-resp"] && !Shopify.designMode) return;
  try {
    
  // iOS sometimes ignores the HTML muted attribute and denies autoplay (WebKit
  // bug); setting muted via JS before play() recovers it. Retry once more on
  // the first touch, which counts as a user gesture and unlocks playback.
  (() => {
    const vids = document.querySelectorAll('.video-banner__media[autoplay]');
    if (!vids.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const kick = () => {
      vids.forEach((v) => {
        if (!v.paused) return;
        v.muted = true;
        const p = v.play();
        if (p) p.catch(() => {});
      });
    };
    kick();
    document.addEventListener('touchend', kick, { once: true, passive: true });
  })();

  } catch(e) { console.error(e); }
})();
})();
